export default __webpack_public_path__ + "static/media/gallery-wip-control-box_03.05399e51.jpg";